/** Vite `base` (e.g. `/` or `/invoice/`). Always ends with `/` when not root. */
export function viteBaseUrl(): string {
  return import.meta.env.BASE_URL || "/";
}

/** Prefix for client routes under subpath deploy (no trailing slash except root → ""). */
export function pathPrefixNoSlash(): string {
  const b = viteBaseUrl();
  if (b === "/" || b === "") {
    return "";
  }
  return b.replace(/\/$/, "");
}

/**
 * Full URL for a client route (HashRouter: `origin` + Vite `base` + `#/` + path).
 * Use for hard redirects (e.g. after logout) so they match hash history.
 */
export function appAbsoluteUrl(path: string): string {
  if (typeof window === "undefined") {
    return path;
  }
  const p = path.replace(/^\/+/, "");
  const prefix = pathPrefixNoSlash().replace(/^\/+|\/+$/g, "");
  const inHash = prefix ? `${prefix}/${p}` : p;
  let root = window.location.origin + (import.meta.env.BASE_URL || "/");
  if (!root.endsWith("/")) {
    root += "/";
  }

  return `${root}#/${inHash}`;
}
